import {
  mdiAccessPoint,
  mdiAccountCheck,
  mdiClockTimeSevenOutline,
  mdiCogs,
  mdiGithub,
  mdiKey,
  mdiKeyVariant,
  mdiMicrosoftAzureDevops,
  mdiPlusMinus,
  mdiRocketLaunch,
  mdiSourcePull,
  mdiSourceRepository,
  mdiToggleSwitch,
  mdiTrashCan,
  mdiCheckCircleOutline,
  mdiNetwork,
  mdiPhone,
} from '@mdi/js'
import type { VuetifyOptions } from 'vuetify'

export const vuetifyOptions: VuetifyOptions = {
  icons: {
    aliases: {
      // Entities
      configurationKey: mdiCogs,
      deployment: mdiRocketLaunch,
      diff: mdiPlusMinus,
      feature: mdiToggleSwitch,
      key: mdiKey,
      networking: mdiNetwork,
      pullRequest: mdiSourcePull,
      repository: mdiSourceRepository,
      reviewer: mdiAccountCheck,
      secret: mdiKeyVariant,
      checkCircle: mdiCheckCircleOutline,
      telephony: mdiPhone,

      // Statuses
      age: mdiClockTimeSevenOutline,
      considerRemoving: mdiAccessPoint,
      unused: mdiTrashCan,

      // Brands
      azureDevops: mdiMicrosoftAzureDevops,
      github: mdiGithub,
    },
  },
}
